/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateSimpleAnnouncementDto } from '../model';
// @ts-ignore
import type { CreateSimpleAnnouncementResponseDto } from '../model';
// @ts-ignore
import type { GetAllSimpleAnnouncementsResponseDto } from '../model';
// @ts-ignore
import type { PaginatedSimpleAnnouncementsResponseDto } from '../model';
// @ts-ignore
import type { SimpleAnnouncementResponseDto } from '../model';
// @ts-ignore
import type { UpdateSimpleAnnouncementDto } from '../model';
// @ts-ignore
import type { UpdateSimpleAnnouncementResponseDto } from '../model';
/**
 * SimpleAnnouncementsApi - axios parameter creator
 * @export
 */
export const SimpleAnnouncementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new simple announcement
         * @param {CreateSimpleAnnouncementDto} createSimpleAnnouncementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerCreate: async (createSimpleAnnouncementDto: CreateSimpleAnnouncementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSimpleAnnouncementDto' is not null or undefined
            assertParamExists('simpleAnnouncementsControllerCreate', 'createSimpleAnnouncementDto', createSimpleAnnouncementDto)
            const localVarPath = `/api/simple-announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSimpleAnnouncementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all simple announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerFindAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/simple-announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all simple announcements with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated: async (page?: number, limit?: number, search?: string, isActive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/simple-announcements/paginated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a simple announcement by ID
         * @param {string} id Simple announcement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerFindById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('simpleAnnouncementsControllerFindById', 'id', id)
            const localVarPath = `/api/simple-announcements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing simple announcement
         * @param {string} id Simple announcement ID
         * @param {UpdateSimpleAnnouncementDto} updateSimpleAnnouncementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerUpdate: async (id: string, updateSimpleAnnouncementDto: UpdateSimpleAnnouncementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('simpleAnnouncementsControllerUpdate', 'id', id)
            // verify required parameter 'updateSimpleAnnouncementDto' is not null or undefined
            assertParamExists('simpleAnnouncementsControllerUpdate', 'updateSimpleAnnouncementDto', updateSimpleAnnouncementDto)
            const localVarPath = `/api/simple-announcements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSimpleAnnouncementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SimpleAnnouncementsApi - functional programming interface
 * @export
 */
export const SimpleAnnouncementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SimpleAnnouncementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new simple announcement
         * @param {CreateSimpleAnnouncementDto} createSimpleAnnouncementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simpleAnnouncementsControllerCreate(createSimpleAnnouncementDto: CreateSimpleAnnouncementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSimpleAnnouncementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simpleAnnouncementsControllerCreate(createSimpleAnnouncementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimpleAnnouncementsApi.simpleAnnouncementsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all simple announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simpleAnnouncementsControllerFindAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllSimpleAnnouncementsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simpleAnnouncementsControllerFindAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimpleAnnouncementsApi.simpleAnnouncementsControllerFindAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all simple announcements with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSimpleAnnouncementsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated(page, limit, search, isActive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimpleAnnouncementsApi.simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a simple announcement by ID
         * @param {string} id Simple announcement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simpleAnnouncementsControllerFindById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimpleAnnouncementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simpleAnnouncementsControllerFindById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimpleAnnouncementsApi.simpleAnnouncementsControllerFindById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing simple announcement
         * @param {string} id Simple announcement ID
         * @param {UpdateSimpleAnnouncementDto} updateSimpleAnnouncementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simpleAnnouncementsControllerUpdate(id: string, updateSimpleAnnouncementDto: UpdateSimpleAnnouncementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateSimpleAnnouncementResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simpleAnnouncementsControllerUpdate(id, updateSimpleAnnouncementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SimpleAnnouncementsApi.simpleAnnouncementsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SimpleAnnouncementsApi - factory interface
 * @export
 */
export const SimpleAnnouncementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SimpleAnnouncementsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new simple announcement
         * @param {CreateSimpleAnnouncementDto} createSimpleAnnouncementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerCreate(createSimpleAnnouncementDto: CreateSimpleAnnouncementDto, options?: RawAxiosRequestConfig): AxiosPromise<CreateSimpleAnnouncementResponseDto> {
            return localVarFp.simpleAnnouncementsControllerCreate(createSimpleAnnouncementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all simple announcements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerFindAll(options?: RawAxiosRequestConfig): AxiosPromise<GetAllSimpleAnnouncementsResponseDto> {
            return localVarFp.simpleAnnouncementsControllerFindAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all simple announcements with pagination
         * @param {number} [page] Page number (default: 1)
         * @param {number} [limit] Number of items per page (default: 10, max: 100)
         * @param {string} [search] Search query to filter challenges by title or description
         * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedSimpleAnnouncementsResponseDto> {
            return localVarFp.simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated(page, limit, search, isActive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a simple announcement by ID
         * @param {string} id Simple announcement ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerFindById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SimpleAnnouncementResponseDto> {
            return localVarFp.simpleAnnouncementsControllerFindById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing simple announcement
         * @param {string} id Simple announcement ID
         * @param {UpdateSimpleAnnouncementDto} updateSimpleAnnouncementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simpleAnnouncementsControllerUpdate(id: string, updateSimpleAnnouncementDto: UpdateSimpleAnnouncementDto, options?: RawAxiosRequestConfig): AxiosPromise<UpdateSimpleAnnouncementResponseDto> {
            return localVarFp.simpleAnnouncementsControllerUpdate(id, updateSimpleAnnouncementDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SimpleAnnouncementsApi - object-oriented interface
 * @export
 * @class SimpleAnnouncementsApi
 * @extends {BaseAPI}
 */
export class SimpleAnnouncementsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new simple announcement
     * @param {CreateSimpleAnnouncementDto} createSimpleAnnouncementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleAnnouncementsApi
     */
    public simpleAnnouncementsControllerCreate(createSimpleAnnouncementDto: CreateSimpleAnnouncementDto, options?: RawAxiosRequestConfig) {
        return SimpleAnnouncementsApiFp(this.configuration).simpleAnnouncementsControllerCreate(createSimpleAnnouncementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all simple announcements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleAnnouncementsApi
     */
    public simpleAnnouncementsControllerFindAll(options?: RawAxiosRequestConfig) {
        return SimpleAnnouncementsApiFp(this.configuration).simpleAnnouncementsControllerFindAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all simple announcements with pagination
     * @param {number} [page] Page number (default: 1)
     * @param {number} [limit] Number of items per page (default: 10, max: 100)
     * @param {string} [search] Search query to filter challenges by title or description
     * @param {boolean} [isActive] Filter by active status (true &#x3D; active, false &#x3D; inactive/cancelled)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleAnnouncementsApi
     */
    public simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated(page?: number, limit?: number, search?: string, isActive?: boolean, options?: RawAxiosRequestConfig) {
        return SimpleAnnouncementsApiFp(this.configuration).simpleAnnouncementsControllerFindAllSimpleAnnouncementsPaginated(page, limit, search, isActive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a simple announcement by ID
     * @param {string} id Simple announcement ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleAnnouncementsApi
     */
    public simpleAnnouncementsControllerFindById(id: string, options?: RawAxiosRequestConfig) {
        return SimpleAnnouncementsApiFp(this.configuration).simpleAnnouncementsControllerFindById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing simple announcement
     * @param {string} id Simple announcement ID
     * @param {UpdateSimpleAnnouncementDto} updateSimpleAnnouncementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SimpleAnnouncementsApi
     */
    public simpleAnnouncementsControllerUpdate(id: string, updateSimpleAnnouncementDto: UpdateSimpleAnnouncementDto, options?: RawAxiosRequestConfig) {
        return SimpleAnnouncementsApiFp(this.configuration).simpleAnnouncementsControllerUpdate(id, updateSimpleAnnouncementDto, options).then((request) => request(this.axios, this.basePath));
    }
}

